/**
 * 平台: fusion端webview
 * 通用能力:
 * 1.bridge fusionBridge
 * 2.登录: fusionLogin | fusionIsLogin
 * 3.定位: fusionLocate
 * 4.订阅: None
 * 5.分享: None
 */
import { utils, payFormatParams, } from '@didi/webx-js-core';
import FusionClass from '@didi/fusion';
import { storage } from '../../../storage';
import { xenv as getXenv, is } from '../../../xenv';
import { getPayParams, passengerFormat } from '../../../pay/payParams';
import { compareVersion } from '../../../version';
import { PassengerJump } from './goTo';
function commonJump(loadParams, xenv, commonParams = {}) {
    new PassengerJump(loadParams, xenv, commonParams).doJump();
}
function initCallMethod(bridge) {
    bridge.call = function (FnName, params, callback) {
        if (typeof FnName !== 'string') {
            console.error('bridge.call FnName必须使用string类型， 传入FnName: ', FnName);
            return;
        }
        if (FnName in bridge) {
            bridge[FnName](params, callback);
        }
        else {
            console.error(`bridge.call 不存在"${FnName}"方法`);
        }
    };
}
let fusionBridge = new FusionClass(['DidiBridgeAdapter', 'TraceModule']);
if (fusionBridge)
    initCallMethod(fusionBridge);
// rewrite
if (fusionBridge?.hideNativeBar) {
    const originalHNB = fusionBridge.hideNativeBar;
    fusionBridge.hideNativeBar = function (option = {}, callback) {
        originalHNB({ ...option }, (res) => {
            const SBH = res?.statusBarHeight >= 0
                ? res.statusBarHeight
                : 0;
            const SBHinCSSPixels = window?.devicePixelRatio > 0
                ? SBH / window.devicePixelRatio
                : SBH / 2;
            const safeAreaInsetTop = Math.round(SBHinCSSPixels * 2.2);
            callback && callback({ ...res, safeAreaInsetTop });
        });
    };
}
const fusionLocate = (option = {}) => {
    return new Promise((resolve, reject) => {
        const finalOption = getXenv() === 'kfpassenger' ? option : {};
        fusionBridge.getLocationInfo(finalOption, function (res) {
            if (res && (res.lat || res.lng || res.cityId || res.city_id)) {
                /* 获取定位信息成功 存入缓存 */
                storage.locationInfo = {
                    lat: Number(res.lat || 0),
                    lng: Number(res.lng || 0),
                    cityId: Number(res.cityId || 0) || Number(res.city_id || 0),
                    area: String(res.area || ''),
                    tripCityId: String(res.trip_cityid || '')
                };
                let newRiskParams = Object.assign({}, storage.riskParams, { latitude: res.lat, longitude: res.lng, cityId: res.cityId || res.city_id });
                utils.cleanEmptyKey(newRiskParams);
                storage.riskParams = newRiskParams;
                resolve({
                    lat: Number(res.lat || 0),
                    lng: Number(res.lng || 0),
                    cityId: Number(res.cityId || 0) || Number(res.city_id || 0),
                    area: String(res.area || ''),
                    tripCityId: String(res.trip_cityid || '')
                });
            }
            else {
                /* 获取定位信息失败 存入缓存 */
                storage.locationInfo = {};
                let newRiskParams = Object.assign({}, storage.riskParams, { latitude: undefined, longitude: undefined, cityId: undefined });
                utils.cleanEmptyKey(newRiskParams);
                storage.riskParams = newRiskParams;
                reject({});
            }
        });
    });
};
const fusionIsLogin = (option, callback) => {
    return new Promise((resolve, reject) => {
        let { useQuick } = option || {};
        fusionBridge.getUserInfo({}, res => {
            if (res && res.phone) {
                const userInfo = {
                    token: res.token || res.ticket,
                    phone: res.phone,
                    uid: res.uid
                };
                /* 获取用户信息成功 存入缓存 */
                storage.userInfo = { ...userInfo };
                let newRiskParams = Object.assign({}, storage.riskParams, { newTicket: res.token || res.ticket });
                utils.cleanEmptyKey(newRiskParams);
                storage.riskParams = newRiskParams;
                /* 执行传入cb */
                useQuick && callback && callback({ ...userInfo });
                resolve({ ...userInfo });
            }
            else {
                /* 获取用户信息失败 存入缓存 */
                storage.userInfo = {};
                let newRiskParams = Object.assign({}, storage.riskParams, { newTicket: undefined });
                utils.cleanEmptyKey(newRiskParams);
                storage.riskParams = newRiskParams;
                reject({});
            }
        });
    });
};
const fusionLogin = () => {
    return new Promise((resolve, reject) => {
        fusionIsLogin().then(resolve, () => {
            fusionBridge.requestLogin({}, res => {
                if (res && (res.userInfo.token || res.userInfo.ticket) && res.userInfo.phone) {
                    /* 获取用户信息成功 存入缓存 */
                    storage.userInfo = {
                        phone: res.userInfo.phone,
                        token: res.userInfo.token,
                        uid: res.userInfo.uid
                    };
                    let newRiskParams = Object.assign({}, storage.riskParams, { newTicket: res.token || res.ticket });
                    utils.cleanEmptyKey(newRiskParams);
                    storage.riskParams = newRiskParams;
                    resolve({
                        phone: res.userInfo.phone,
                        token: res.userInfo.token,
                        uid: res.userInfo.uid
                    });
                }
                else {
                    /* 获取用户信息失败 存入缓存 */
                    storage.userInfo = {};
                    let newRiskParams = Object.assign({}, storage.riskParams, { newTicket: undefined });
                    utils.cleanEmptyKey(newRiskParams);
                    storage.riskParams = newRiskParams;
                    reject({
                        extraInfo: {
                            login_result: res.login_result
                        }
                    });
                }
            });
        });
    });
};
const fusionSetLoginConfig = () => { };
const fusionSetShare = (option) => {
    /* 这里是通过setShare收集到的分享动作完成后的回调 */
    /* TODO: 涉及添加多个参数来接收回调 之前K是放在config里 不放在config里则会多出N个参数 */
    // window.__showEntranceCallBack__ = function (ret) {
    //   // ret
    //   // share_result: Number  // -1：需要授权，0：成功，1：失败，2：取消
    //   // channel: String // wechat
    //   if (typeof ret === 'string') {
    //     try {
    //       ret = JSON.parse(ret)
    //     } catch (e) {
    //       ret = {}
    //     }
    //   }
    //   if (ret.share_result === 0) {
    //     if (config.success) config.success(ret)
    //   } else if (ret.share_result === 2) {
    //     if (config.cancel) config.cancel(ret)
    //   } else {
    //     if (config.fail) config.fail(ret)
    //   }
    // }
    fusionBridge.initEntrance(option);
    fusionBridge.showEntrance(option);
};
const fusionDisableShare = () => {
    fusionBridge.hideEntrance({});
};
const getChannel = (option) => {
    return option && option.channel;
};
const fusionInvokeShare = (option) => {
    if ('buttons' in option) {
        /* 多渠道invokeShare 拉起面板 */
        fusionBridge.initEntrance(option);
        fusionBridge.invokeEntrance(option);
    }
    else if ('channel' in option) {
        /* 单渠道分享 取config中channel作为目标渠道 */
        const method = getChannel(option);
        if (method in fusionBridge) {
            fusionBridge[method](option);
        }
    }
};
const fusionPay = (params) => {
    if (typeof params === 'string') {
        params = {
            options: {
                out_trade_id: params
            }
        };
    }
    let { pay, options, out_trade_id, token, ...args } = params;
    /* 增加埋点 */
    try {
        window.PerfTrack.customTrack('$_use_pay_is_new', {
            is_new: options ? 1 : 0,
        });
        // eslint-disable-next-line no-empty
    }
    catch (_) { }
    const passengerPrograms = getPayParams('passenger');
    const payInfo = utils.merge({}, passengerPrograms, {
        options: options || pay || {
            out_trade_id: out_trade_id,
            token: token,
        },
        ...args
    });
    const paramsFormat = payFormatParams(passengerFormat, payInfo);
    return new Promise((resolve, reject) => {
        fusionBridge.openUniPay(paramsFormat.options, function (res) {
            if (res.code === 1) {
                resolve(res);
            }
            else {
                reject(res);
            }
        });
    });
};
const kffusionPay = (options) => {
    if (typeof options === 'string') {
        options = {
            pay: {
                out_trade_id: options
            }
        };
    }
    let { pay } = options;
    if (!pay) {
        pay = {
            out_trade_id: options.out_trade_id,
            token: options.token
        };
    }
    return new Promise((resolve, reject) => {
        fusionBridge.openUniPay(pay, function (res) {
            if (res.code === 0) {
                resolve(res);
            }
            else {
                reject(res);
            }
        });
    });
};
const fusionSaveImg = (url) => {
    return new Promise((resolve, reject) => {
        fusionBridge.saveImage({
            type: 'image',
            image: url
        }, res => {
            if (+res.share_result === 0) {
                resolve(res);
            }
            else {
                reject(res);
            }
        });
    });
};
const fusionGetSystemInfo = () => {
    return new Promise((resolve) => {
        fusionBridge.getSystemInfo({}, (res) => {
            const result = {
                ...res,
                ddfp: res.ddfp || res.imei
            };
            delete result.imei;
            resolve(result);
        });
    });
};
const fusionScanCode = () => {
    return new Promise((resolve, reject) => {
        fusionBridge.launchScan({}, res => {
            if (res.result === 1 || res.err === 0) {
                const result = res.message || res.ret;
                resolve({
                    result,
                });
            }
            else {
                reject({});
            }
        });
    });
};
const fusionCalendar = async (option) => {
    if (!fusionBridge?.writeEventToCalendar) {
        return Promise.reject({ success: false, code: -1 });
    }
    const isCanUseCalendar = await fusionCanUseCalendar(option?.extParams?.limitVersion);
    // 版本不满足时直接返回
    if (!isCanUseCalendar) {
        return Promise.reject({ success: false, code: -1 });
    }
    return new Promise((resolve, reject) => fusionBridge.writeEventToCalendar(option, ({ code }) => {
        // 写入结果，0-成功 1-本次拒绝授权 2-上次拒绝授权 3-数据异常 4-日历账户获取失败 5-日程插入失败 6-重复添加 7-不支持写入日历操作 99-其他原因
        const isSuccess = code === 0 || code === 6;
        const res = { success: isSuccess, code };
        if (isSuccess) {
            return resolve(res);
        }
        return reject(res);
    }));
};
const fusionCanUseCalendar = async (limitVersion) => {
    const sysInfo = await fusionGetSystemInfo();
    const version = sysInfo?.appversion;
    // 提取限制版本信息
    const { ios: iosLimitVersion, android: androidLimitVersion, harmonyos: harmonyosVersion } = limitVersion || {};
    // 检查当前环境是否满足版本限制
    const isVersionUnsupported = (is('passenger.ios') && compareVersion(version, iosLimitVersion || '6.7.18') < 0) ||
        (androidLimitVersion && is('passenger.android') && compareVersion(version, androidLimitVersion) < 0) ||
        (harmonyosVersion && is('passenger.harmonyos') && compareVersion(version, harmonyosVersion) < 0);
    return !isVersionUnsupported;
};
export { fusionBridge, fusionIsLogin, fusionLogin, fusionSetLoginConfig, fusionLocate, fusionDisableShare, fusionSetShare, fusionInvokeShare, fusionPay, kffusionPay, fusionSaveImg, fusionGetSystemInfo, fusionScanCode, commonJump as passengerCommonJump, fusionCalendar, fusionCanUseCalendar, };
